import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/SurveyManagement';
import SurveyManagement from '../../../pages/Admin/SurveyManagement/SurveyManagement';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => {
    const isLoading = state.surveyManagement.getSurvey.isFetching
    || state.surveyManagement.updateSurvey.isFetching;
    return ({
        eventInfo: state.eventManagement.infoEvent.data,
        surveyData: state.surveyManagement.getSurvey.data,
        isFetchingUpdate: state.surveyManagement.updateSurvey.isFetching,
        errorsUpdate: state.surveyManagement.updateSurvey.errors,
        updateSuccess: state.surveyManagement.updateSurvey.success,
        isLoading,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchClearGetSurvey: () => dispatch(Actions.ClearGetSurvey()),
    fetchGetSurvey: (param) => dispatch(Actions.GetSurveyRequested(param)),
    fetchClearUpdateSurvey: () => dispatch(Actions.ClearUpdateSurvey()),
    fetchUpdateSurvey: (params) => dispatch(Actions.UpdateSurveyRequested(params)),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SurveyManagement);
